// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class LibraryCardConfirmActionDialogController {
   $uibModalInstance: any
   i18n: any
   constructor($uibModalInstance: any, translationService: any) {
      this.$uibModalInstance = $uibModalInstance
      this.i18n = translationService
   }

   cancel() {
      return this.$uibModalInstance.dismiss('cancel')
   }

   accept() {
      return this.$uibModalInstance.close('ok')
   }
}


LibraryCardConfirmActionDialogController.$inject = ['$uibModalInstance', 'translationService']

angular.module('summonApp.controllers')
   .controller('libraryCardConfirmActionDialogController', LibraryCardConfirmActionDialogController)
